import React, { createContext, useCallback, useContext, useEffect, useReducer } from 'react';
import api from '../api';
import { getCustomer } from '../services/customerService';
const FavoriteContext = createContext();
const list = value => Array.isArray(value) ? value.filter(i => i?.id) : [];
function reducer(state, action) {
  const ownerPhone = action.ownerPhone ?? state.ownerPhone;
  if (action.type === 'HYDRATE_FAVORITES' && state.hydrated && state.ownerPhone === ownerPhone) return state;
  if (['LOAD_FAVORITES', 'HYDRATE_FAVORITES'].includes(action.type)) return { items: list(action.payload), ownerPhone, hydrated: true };
  if (action.type === 'CLEAR_FAVORITES') return { items: [], ownerPhone: null, hydrated: false };
  if (action.type === 'TOGGLE_FAVORITE') return { ...state, items: state.items.some(i => Number(i.id) === Number(action.payload.id)) ? state.items.filter(i => Number(i.id) !== Number(action.payload.id)) : [...state.items, action.payload] };
  return state;
}
export function FavoriteProvider({ children }) {
  const [state, reduce] = useReducer(reducer, null, () => { try { return { items: list(JSON.parse(localStorage.getItem('favorites') || '[]')), ownerPhone: null, hydrated: false }; } catch { return { items: [], ownerPhone: null, hydrated: false }; } });
  const dispatch = useCallback(action => reduce({ ...action, ownerPhone: action.ownerPhone ?? getCustomer()?.phone }), []);
  useEffect(() => {
    localStorage.setItem('favorites', JSON.stringify(state.items));
    if (!state.hydrated || getCustomer()?.phone !== state.ownerPhone || !localStorage.getItem('customerAccessToken')) return undefined;
    const timer = setTimeout(() => api.put('/api/auth/profile', { favorites: JSON.stringify(state.items) }).catch(() => {}), 500);
    return () => clearTimeout(timer);
  }, [state]);
  const items = state.hydrated && state.ownerPhone === getCustomer()?.phone && localStorage.getItem('customerAccessToken') ? state.items : [];
  return <FavoriteContext.Provider value={{ items, dispatch, isFavorite: id => items.some(i => Number(i.id) === Number(id)) }}>{children}</FavoriteContext.Provider>;
}
export const useFavorites = () => useContext(FavoriteContext);
